import React from 'react';
import type { GroupBase, OptionProps } from 'react-select';
import { components } from 'react-select';
import type { EntitySelectCategorizedSearchResult } from './CategorizedEntitySelect';
import { useIsAnimatingMenuList } from './EntitySelectMenuList';
import NewSelectOption from './NewSelectOption';
import GroupSelectOption from '../../groups/GroupSelectOption';
import PostSelectOption from '../../post/PostSelectOption';
import TopicSelectOption from '../../topic/TopicSelectOption';
import UserSelectOption from '../../user/UserSelectOption';

const COMPONENT_MAP = {
  group: GroupSelectOption,
  post: PostSelectOption,
  topic: TopicSelectOption,
  user: UserSelectOption,
  new: NewSelectOption,
} as const;

const EntitySelectCategoryOption = <
  IsMulti extends boolean,
  GroupType extends
    GroupBase<EntitySelectCategorizedSearchResult> = GroupBase<EntitySelectCategorizedSearchResult>,
>(
  props: OptionProps<EntitySelectCategorizedSearchResult, IsMulti, GroupType>,
) => {
  const isAnimating = useIsAnimatingMenuList();

  if (props.data.type === 'topic') {
    return (
      <components.Option {...props}>
        <TopicSelectOption
          {...props.data}
          secondary={undefined}
          secondaryTop={props.data.secondary}
          focused={props.isFocused}
          truncate
        />
      </components.Option>
    );
  }
  const Component = COMPONENT_MAP[props.data.type];
  return (
    <components.Option {...props}>
      {/* @ts-expect-error */}
      <Component
        {...props.data}
        focused={props.isFocused}
        disablePreview={isAnimating}
      />
    </components.Option>
  );
};

export default EntitySelectCategoryOption;
